














import Vue from 'vue'
import moment from 'moment/moment'
import request from '@/utils/request'
import roleMessenger from './role_messenger.vue'
import roleReservoir from './role_reservoir.vue'
export default Vue.extend({
    components: {roleMessenger, roleReservoir},
    data() {
        return {
            type: '',
            tag: '2',
            dataObj: {}as any,
        }
    },
    created() {
        this.getData()
    },
    methods: {
        getData() {
            request.get('/api/account/rest_manager_apply').then((res: any) => {
                // console.log(res)
                if (!res || !res.id) {
                    this.$router.push('/apply_role')
                    // return
                }
                const { type, state } = res
                this.dataObj = res
                if (state === 2) {
                    this.type = String(type)
                } else {
                    this.$router.push('/apply_role')
                }
            }).catch((err) => {
                console.log(err)
                this.$Message.warning(err)
            })
        },
    },
    filters: {
    },
})
